var styles = {
  "SelectAllActions": "Polaris-SelectAllActions",
  "SelectAllActions-not-sticky": "Polaris-SelectAllActions--selectAllActionsNotSticky",
  "SelectAllActions-entering": "Polaris-SelectAllActions__SelectAllActions--entering",
  "SelectAllActions-exiting": "Polaris-SelectAllActions__SelectAllActions--exiting",
  "SelectAllActions-hasPagination": "Polaris-SelectAllActions__SelectAllActions--hasPagination",
  "SelectAllActions-exited": "Polaris-SelectAllActions__SelectAllActions--exited",
  "SelectAllActions-entered": "Polaris-SelectAllActions__SelectAllActions--entered",
  "AllAction": "Polaris-SelectAllActions__AllAction"
};

export { styles as default };
